<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div class="co-payments-sections-container">
		<v-flex mb2 d-flex xs12 pa-0 grow v-if="step === $const.STEP_PAYMENT">
			<div class="co-section">
				<v-card flat width="100%" class="mb-1">
					<div>
						<div>
							<div class="section-title">
								<h2 class="active" v-bind="ADAattr('h1')" aria-level="2" role="heading">
									Select Payment Methods
								</h2>
							</div>

							<v-expand-transition>
								<div v-show="!placing_order">

									<div class="co-payments-sections">
										<v-container grid-list-md pa-0>
											<v-layout row>
												<v-flex xs12 pa-0>
													<v-card align-start flat>
													</v-card>
													<v-card-text class="pa-0">

														<v-expand-transition>
															<div v-if="show_split_payment">
																<template>
																	<div class="co-payments-section-with-permissions">
																		<ul class="co-payments-selector mr-4">
																			<template v-for="method in available_payment_methods">
																				<single-payment-method
																						:method="method"
																						:payments="payments"
																						:only="selected_restricted_method"
																						no-divider

																						@selected="onPaymentMethodSelected"
																						@submitted-braintree="onBraintreeSubmit"
																						@submitted-student-card="onStudentCardSubmit"
																						@updated-financial-aid="onUpdatedFinancialAid"
																				></single-payment-method>
																			</template>
																		</ul>

																		<div class="co-payments-section-books">

																			<h3 v-bind="ADAattr('focus')">
																				<v-icon color="#FF7000">error_outline</v-icon>
																				<span v-if="permitted_items == null || permitted_items.length > 0">
																						Items eligible for payment by {{ getPaymentMethodCaption() }}:
																				</span>
																				<span v-else>
																						You have no eligible items, or insufficient balance to cover eligible items
																				</span>
																			</h3>

																			<ul class="co-products-list">
																				<li v-if="eligible_items === null">
																					<v-progress-circular
																							indeterminate
																							color="primary"
																							v-bind="ADAattr('progress', 'Loading eligible items')"
																					></v-progress-circular>
																				</li>
																				<li v-for="item in permitted_items">
																					<div class="copl-cover">
																						<v-img
																								:src="item.cover"
																								height="70px"
																								contain
																								position="center center"
																								v-bind="ADAattr('hidden')"
																						></v-img>
																					</div>
																					<div class="copl-info">
																						<h4 v-bind="[
																							ADAattr('focus'),
																							ADAattr('label', ADAitemLabel(item.title, item.isbn))
																						]">
																							{{ item.title }}
																						</h4>
																						<div v-bind="[
																							ADAattr('focus'),
																							ADAattr('label', `Price per item: $${formatPrice(item.price)}`)
																						]">
																							<strong v-bind="ADAattr('hidden')">{{ `$${formatPrice(item.price)}` }}</strong>
																						</div>
																						<div v-bind="[
																							ADAattr('focus'),
																							ADAattr('label', `Quantity: ${item.quantity}, condition: ${item.condition_text},
																							${item.condition_additional ? item.condition_additional : ''}`)
																						]">
																							<span v-bind="ADAattr('hidden')">
																								{{ `Qty: ${item.quantity}, Condition: ${item.condition_text}
																								${item.condition_additional ? item.condition_additional : ''}` }}
																							</span>
																						</div>
																					</div>
																				</li>
																			</ul>
																			<div class="co-permissions-totals" v-if="permitted_subtotal" v-bind="ADAattr('focus')">
																				Subtotal: <strong>${{ formatPrice(permitted_subtotal) }}</strong>
																			</div>
																		</div>
																	</div>

																	<div class="co-payments-section-without-permissions">
																		<div class="co-payments-section-books">

																			<h3 v-bind="ADAattr('focus')">
																				<v-icon color="#FF7000">error_outline</v-icon>
																				Items ineligible for {{ getPaymentMethodCaption() }}, or priced above your available balance.
																				You must pay for these by credit or debit card, or through another supported payment method:
																			</h3>

																			<ul class="co-products-list">
																				<li v-if="eligible_items === null">
																					<v-progress-circular
																							indeterminate
																							color="primary"
																							v-bind="ADAattr('progress', 'Loading eligible items')"
																					></v-progress-circular>
																				</li>
																				<li v-for="item in non_permitted_items">
																					<div class="copl-cover">
																						<v-img
																								:src="item.cover"
																								height="70px"
																								contain
																								position="center center"
																								v-bind="ADAattr('hidden')"
																						></v-img>
																					</div>
																					<div class="copl-info">
																						<h4 v-bind="[
																							ADAattr('focus'),
																							ADAattr('label', ADAitemLabel(item.title, item.sku))
																						]">
																							{{ item.title }}
																						</h4>
																						<div v-bind="[
																							ADAattr('focus'),
																							ADAattr('label', `Price per item: $${formatPrice(item.price)}`)
																						]">
																							<strong v-bind="ADAattr('hidden')">{{ `$${formatPrice(item.price)}` }}</strong>
																						</div>
																						<div v-bind="[
																							ADAattr('focus'),
																							ADAattr('label', `Quantity: ${item.quantity}, condition: ${item.condition_text},
																							${item.condition_additional ? item.condition_additional : ''}`)
																						]">
																							<span v-bind="ADAattr('hidden')">
																								{{ `Qty: ${item.quantity}, Condition: ${item.condition_text}
																								${item.condition_additional ? item.condition_additional : ''}` }}
																							</span>
																						</div>
																					</div>
																				</li>
																			</ul>
																			<div class="co-permissions-totals" v-if="non_permitted_subtotal" v-bind="ADAattr('focus')">
																				Subtotal: <strong>${{ formatPrice(non_permitted_subtotal) }}</strong>
																			</div>

																		</div>

																		<ul class="co-payments-selector mr-4">
																			<template v-for="method in available_payment_methods">
																				<single-payment-method
																						:method="method"
																						:payments="payments"
																						:without="selected_restricted_method"

																						@selected="onPaymentMethodSelected"
																						@submitted-braintree="onBraintreeSubmit"
																						@submitted-student-card="onStudentCardSubmit"
																						@updated-financial-aid="onUpdatedFinancialAid"
																				></single-payment-method>
																			</template>
																		</ul>
																	</div>
																</template>
															</div>
														</v-expand-transition>

														<v-expand-transition>
															<div v-if="!show_split_payment">
																<template>
																	<div class="co-payments-section-no-permissions">
																		<ul class="co-payments-selector mr-4">
																			<template v-for="method in available_payment_methods">
																				<single-payment-method
																						:method="method"
																						:payments="payments"

																						@selected="onPaymentMethodSelected"
																						@submitted-braintree="onBraintreeSubmit"
																						@submitted-student-card="onStudentCardSubmit"
																						@updated-financial-aid="onUpdatedFinancialAid"
																				></single-payment-method>
																			</template>
																		</ul>
																	</div>
																</template>
															</div>
														</v-expand-transition>

														<div class="co-payments-section-additional" v-show="!hide_cc_selector">
															<ul class="co-payments-selector mr-4">
																<template v-show="payments.credit_cards && payments.credit_cards.options"
																		  v-if="$globs['credit_cards_enabled']">
																	<li class="cops-cc pb-3">
																		<v-checkbox
																				:disabled="!payments.credit_cards.enabled"
																				v-model="payments.credit_cards.use_cc"
																				label="Use a credit or debit card"
																				hide-details
																				class="mt-3"
																				@change="onPaymentMethodSelected({type: 'cc', method: payments.credit_cards})"
																		></v-checkbox>
																		<div v-if="!payments.credit_cards.enabled" v-bind="ADAattr('sr-only')">
																			Select a credit or debit card
																		</div>

																		<v-radio-group
																				v-model="payments.credit_cards.selected_cc"
																				v-if="payments.credit_cards.use_cc"
																				class="ml-4 mt-1 mb-3 co-select-cc-rg"
																				hide-details
																				@change="onChangedCC"
																		>
																			<v-flex grid-list-md pa-0 grow>

																				<v-layout wrap justify-space-between>
																					<v-flex xs12 v-for="(cc, cc_index) in payments.credit_cards.options"
																							:key="cc_index"
																							grow
																							py-0>
																						<div>
																							<v-container pa-0>
																								<v-layout wrap>
																									<v-flex xs10>
																										<v-radio
																												class="py-3 my-0"
																												:value="cc_index"
																												:disabled="!enabledCC(cc)"
																												v-bind="ADAattr('label', `Card label: ${cc.label}, type: ${cc.card_type},
																												last 4 digits: ${ADAreadEachSymbol(cc.account_number)}`)"
																										>
																											<template v-slot:label="">
																												<div style="word-break: break-word">
																													{{ `${cc.label}, ${cc.card_type} ****
																													${cc.account_number}`
																													}}
																												</div>
																											</template>

																										</v-radio>
																									</v-flex>

																									<v-flex xs1 class="py-3 my-0 text-md-right">
																										<a @click="edit_cc = cc" v-if="payments.credit_cards.cc_type === 'cc'"
																											v-bind="[
																												ADAattr('focus'),
																												ADAattr('label', 'Edit Credit Card ' + cc.account_number),
																											]"
																										>Edit</a>
																									</v-flex>

																									<v-flex xs1 v-if="!enabledCC(cc)">
																										<v-card flat>
																											<v-card-text class="pa-0">
																												<v-tooltip bottom color="#2170f2">
																													<template v-slot:activator="{ on }">
																														<v-btn icon v-on="on" v-bind="ADAattr('hidden')">
																															<v-icon color="#4185F4">info
																															</v-icon>
																														</v-btn>
																													</template>
																													<span>{{ $globs['forbidden_rental_text'] }}</span>
																												</v-tooltip>
																											</v-card-text>
																										</v-card>
																									</v-flex>

																									<v-flex
																											xs4
																											v-if="cc.card_type === 'SC' && payments.credit_cards.selected_cc === cc_index"
																											class="co-sc-cvv-block"
																									>
																										<v-form
																												v-model="sc_cvv_model"
																												ref="sc_cvv_form"
																												lazy-validation
																										>
																											<v-text-field
																													v-model="sc_cvv"
																													label="CVV"
																													class="co-text-field"
																													mask="###"
																													:rules="rules.sc_cvv"
																											></v-text-field>
																										</v-form>
																									</v-flex>

																								</v-layout>
																							</v-container>

																							<edit-credit-card-form
																								v-if="payments.credit_cards.cc_type === 'cc' && edit_cc && edit_cc.id === cc.id"
																								ref="edit_cc_form"
																								:invalid-fields="edit_cc_invalid_fields"
																								:saved-card-data="edit_cc"
																								:error-message="edit_cc_error"
																								:loading="saving_edited_cc"
																								@save="onEditCreditCardSubmit"
																								@cancel="edit_cc = null"
																							></edit-credit-card-form>

																						</div>

																						<v-divider v-bind="ADAattr('hidden')"></v-divider>
																					</v-flex>
																					<v-flex xs12 grow py-0>
																						<v-radio class="pt-3 my-0" :value="-1" label="Add credit or debit card"></v-radio>
																					</v-flex>
																				</v-layout>
																			</v-flex>
																		</v-radio-group>

																		<div v-show="payments.credit_cards.use_cc && (payments.credit_cards.selected_cc === -1 || edit_cc !== null)">
																			<div v-if="payments.student_card" class="co-cc-type-selector-container">
																				<div class="co-cc-type-selector-title">Select Card Type:</div>

																				<v-radio-group
																						v-model="payments.credit_cards.cc_type"
																						hide-details
																						class="co-cc-type-selector"
																				>
																					<v-radio value="cc" label="Credit Card"></v-radio>
																					<v-radio value="sc" :label="payments.student_card"></v-radio>
																				</v-radio-group>
																			</div>

																			<braintree-cc-form
																					v-if="payments.credit_cards.cc_type === 'cc' && !edit_cc"
																					ref="braintree_hosted_fields_form"
																					:braintree_token="$globs['braintree_token']"
																					:save_card_required="$globs['has_rental']"
																					:enable-same-address-as-shipping="enableSameAddressAsShipping"
																					:invalid-fields="braintree_invalid_fields"
																					@submit="onBraintreeSubmit"
																					@deviceDataReceived="onBraintreeDeviceDataReceived"
																			></braintree-cc-form>

																			<student-card-form
																					v-if="payments.credit_cards.cc_type === 'sc'"
																					ref="student_card_form"
																					:student_card="payments.student_card"
																					:enable-same-address-as-shipping="enableSameAddressAsShipping"
																					@submit="onStudentCardSubmit"
																			></student-card-form>
																		</div>

																		<v-divider class="mt-3" v-bind="ADAattr('hidden')"></v-divider>
																	</li>

																</template>


																<li class="cops-flexpay pb-3" v-if="flexpayStore">
																	<v-container grid-list-md pa-0>

																		<v-layout wrap justify-space-between>
																			<v-flex xs12>
																				<div v-bind="ADAattr('focus')">
																					Please enter your Flex Pay Username and Password
																				</div>
																			</v-flex>
																			<v-flex xs4>
																				<v-text-field
																						v-model="flexpay.username"
																						label="Username"
																						required
																						class="co-text-field"
																						v-bind="ADAattr('label', 'Flex pay username')"
																				></v-text-field>
																			</v-flex>
																			<v-flex xs8></v-flex>
																			<v-flex xs4>
																				<v-text-field
																						v-model="flexpay.password"
																						label="Password"
																						type="password"
																						required
																						class="co-text-field"
																						v-bind="ADAattr('label', 'Flex pay password')"
																				></v-text-field>
																			</v-flex>
																			<v-flex xs8></v-flex>
																		</v-layout>
																	</v-container>
																</li>

																<li v-if="$globs['credit_cards_enabled'] && !$globs['has_rental']">
																	<v-expand-transition>
																		<v-container grid-list-md pa-0 v-show="third_party_enabled">

																			<v-layout wrap class="cops-3rd-party pb-3">
																				<v-flex class="cops-3rd-party-btn"
																						v-if="payments.third_party.options.paypal.enable_paypal">
																					<pay-pal-buttons
																							:braintree_token="$globs['braintree_token']"
																							:environment="payments.third_party.options.paypal.paypal_environment"
																							:paypal_enabled="payments.third_party.options.paypal.enable_paypal"
																							:paypal_credit_enabled="payments.third_party.options.paypal.enable_paypal_credit"
																							@error="err => log('paypal error', err)"
																							@cancel="err => log('customer canceled paypal process', err)"
																							@tokenized="onPayPalTokenized"
																					></pay-pal-buttons>
																				</v-flex>

																				<with-root
																						v-bind:showIf="payments.third_party.options.paypal.enable_paypal_credit">
																					<v-flex class="cops-3rd-party-btn">
																						<v-flex class="cops-3rd-party-btn2"
																								v-bind:class="{ 'add-margin-a': !payments.third_party.options.paypal.enable_paypal_credit}">
																							<apple-pay-button
																									v-if="payments.third_party.options.apple_pay.enable_apple_pay"
																									:braintree_token="$globs['braintree_token']"
																									:amount_to_pay="amount_to_authorize"
																									@error="err => log(err)"
																									@tokenized="onApplePayTokenized"
																							></apple-pay-button>
																						</v-flex>
																						<v-flex class="cops-3rd-party-btn2"
																								v-bind:class="{ 'add-margin-g': !payments.third_party.options.paypal.enable_paypal_credit}">
																							<google-pay-button
																									v-if="payments.third_party.options.google_pay.enable_google_pay"
																									:braintree_token="$globs['braintree_token']"
																									:environment="payments.third_party.options.google_pay.google_pay_environment"
																									:google_pay_merchant_id="payments.third_party.options.google_pay.google_pay_merchant_id"
																									@error="err => log('google pay error', err)"
																									@cancel="err => log('customer canceled google pay process', err)"
																									@tokenized="onGooglePayTokenized"
																							></google-pay-button>
																						</v-flex>
																					</v-flex>
																				</with-root>
																			</v-layout>
																		</v-container>
																	</v-expand-transition>
																</li>

																<li v-if="$globs['gift_certificates_enabled']">
																	<v-container grid-list-md pa-0>

																		<v-layout wrap justify-space-between class="cops-add pb-3">
																			<v-flex md6 class="cops-add-caption">
																				<div>
																					<strong>{{ $globs['gift_certificate_label'] || "Add a Gift Code or other Payment Code"}}</strong>
																				</div>
																				<v-layout>
																					<v-flex xs8 py-0>
																						<v-text-field
																								v-model="add_coupon_code"
																								label="Enter Code"
																								class="co-text-field"
																								v-bind="ADAattr('label', ADAgiftCertificateLabel('Enter', $globs['gift_certificate_label']))"
																						></v-text-field>
																					</v-flex>
																					<v-flex>
																						<div v-if="add_coupon_code" class="co-code-submit-btn-block">
																							<v-btn
																								@click="applyCoupon"
																								v-bind="ADAattr('label', ADAgiftCertificateLabel('Apply', $globs['gift_certificate_label']))"
																							>
																								Apply
																							</v-btn>
																						</div>
																					</v-flex>
																				</v-layout>
																			</v-flex>
																			<v-flex md6 class="cops-add-caption" v-if="!$globs['hide_discount_form']">
																				<div>
																					<strong>Add a Discount Code</strong>
																				</div>
																				<v-layout>
																					<v-flex xs8 py-0>
																						<v-text-field
																								v-model="add_discount_code"
																								label="Enter Code"
																								class="co-text-field"
																								v-bind="ADAattr('label', 'Enter a discount code')"
																						></v-text-field>
																					</v-flex>
																					<v-flex>
																						<div v-if="add_discount_code" class="co-code-submit-btn-block">
																							<v-btn @click="applyDiscount" v-bind="ADAattr('label', 'Apply a discount code')">Apply</v-btn>
																						</div>
																					</v-flex>
																				</v-layout>
																			</v-flex>
																		</v-layout>
																	</v-container>
																</li>
															</ul>
														</div>
													</v-card-text>

												</v-flex>
											</v-layout>
										</v-container>

									</div>

									<div v-if="payPalPaymentData" class="mx-4">
										<hr class="mt-3 v-divider theme--light">
										<h2 class="py-2">Payment via PayPal Account:</h2>
										<v-layout class="third-party-payment-info-block">
											<p class="mx-1" v-bind="ADAattr('focus')">
												Paying with PayPal account {{payPalPaymentData.details.email}}!
											</p>
											<a href="#"
											   class="co-change-link mr-1"
											   @click.prevent="cancelPayPalPayment"
											   v-bind="ADAattr('label', 'Cancel PayPal payment')"
											>
												Change
											</a>
										</v-layout>
									</div>

									<div v-if="googlePayPaymentData" class="mx-4">
										<hr class="mt-3 v-divider theme--light">
										<h2 class="py-2">Payment via Google Pay:</h2>
										<v-layout class="third-party-payment-info-block">
											<p class="mx-1" v-bind="ADAattr('focus')">
												Paying with Google Pay ({{googlePayPaymentData.details.cardType}}
												*{{googlePayPaymentData.details.lastFour}})!
											</p>
											<a href="#"
											   class="co-change-link mr-1"
											   @click.prevent="cancelGooglePayPayment"
											   v-bind="ADAattr('label', 'Cancel Google Pay payment')"
											>
												Change
											</a>
										</v-layout>
									</div>

									<div v-if="applePayPaymentData" class="mx-4">
										<hr class="mt-3 v-divider theme--light">
										<h2 class="py-2">Payment via Apple Pay:</h2>
										<v-layout class="third-party-payment-info-block">
											<p class="mx-1" v-bind="ADAattr('focus')">
												Paying with your Apple Pay card ({{applePayPaymentData.details.paymentInstrumentName}})!
											</p>
											<a href="#"
											   class="co-change-link mr-1"
											   @click.prevent="cancelApplePayPayment"
											   v-bind="ADAattr('label', 'Cancel Apple Pay payment')"
											>
												Change
											</a>
										</v-layout>
									</div>

									<v-container grid-list-md pa-0 class="co-save-password-container">
										<v-layout row>
											<v-flex xs12 pa-0>
												<v-card align-start flat>
													<v-card-text class="pa-0">

														<div class="co-save-password-block" v-if="!is_logged_in">
															<v-container grid-list-md pa-4>
																<v-layout wrap>
																	<v-flex xs12 py-0>
																		<h3 class="co-save-password-block-title" v-bind="ADAattr('focus')">Create Account</h3>

																		<p v-if="$globs['account_required']" v-bind="ADAattr('focus')">
																			Your school requires that you create an account to continue.
																		</p>
																		<p v-if="account_required" v-bind="ADAattr('focus')">
																			As your order contains {{ contained_required_types }},
																			you need to create an account to continue.
																		</p>
																		<p v-else>
																			Save your information for next time!

																			<span v-if="$globs['show_full_save_password_hint']" v-bind="ADAattr('sr-only')">
																				Please enter your password and we'll create an account for you.
																				You will then be able to log in using your email address and the password you choose.
																				Please note that by creating an account you agree to our <a target="_blank" href="/service/exchange/member-agreement.php">marketplace terms and conditions</a>.
																			</span>
																		</p>
																	</v-flex>

																	<v-flex xs6 py-0>
																		<div class="co-save-password-form">
																			<v-form
																					v-model="password.form"
																					lazy-validation=""
																					ref="save_password_form"
																			>
																				<v-text-field
																						v-model="password.first"
																						type="password"
																						label="Password"
																						class="co-text-field mt-0"
																						:rules="rules.password1"
																						@change="$refs.save_password_form.validate()"
																				></v-text-field>
																				<v-text-field
																						v-model="password.second"
																						type="password"
																						label="Re-type password"
																						class="co-text-field mt-0"
																						:rules="rules.password2"
																						@change="$refs.save_password_form.validate()"
																				></v-text-field>
																			</v-form>
																		</div>
																	</v-flex>
																	<v-flex xs12 py-0>

																		<p v-if="$globs['show_full_save_password_hint']" v-bind="ADAattr('hidden')">
																			<strong>
																				Please enter your password and we'll create an account for you. You will
																				then be
																				able to log
																				in
																				using
																				your email address and the password you choose.
																			</strong>
																			<br/>

																			Please note that by creating an account you agree to our
																			<a target="_blank" href="/service/exchange/member-agreement.php" v-bind="ADAattr('hidden')">
																				marketplace terms and conditions
																			</a>.
																		</p>

																	</v-flex>
																</v-layout>
															</v-container>
														</div>

													</v-card-text>
												</v-card>
											</v-flex>
										</v-layout>
									</v-container>


									<div class="co-captcha-panel"
										 v-if="$globs['captcha_settings'] && $globs['captcha_settings']['show_order_captcha']"
										 v-show="!captcha_response"
									>
										<vue-recaptcha
												ref="recaptcha"
												@verify="onCaptchaVerify"
												:sitekey="$globs['captcha_settings']['public_key']"
												size="normal"
										>
										</vue-recaptcha>
									</div>
								</div>
							</v-expand-transition>

							<v-expand-transition>
								<div v-if="placing_order">
									<div class="co-submit-placing-order">
										<h4>Placing your order...</h4>
										<v-progress-linear :indeterminate="true" v-bind="ADAattr('progress', 'Please wait, we are placing your order')"></v-progress-linear>
									</div>
								</div>
							</v-expand-transition>

						</div>

					</div>
				</v-card>
			</div>
		</v-flex>

		<v-flex mb2 d-flex xs12 pa-0 v-if="step === $const.STEP_PAYMENT">
			<div class="co-section">
				<v-card flat>
					<div class="py-3">
					  <div class="co-submit-panel">
						<div class="agreement-text" v-if="has_ebook">
						  By placing this order I understand that I am purchasing a license to access this product under the terms provided, and not ownership of the product.
						  <div class="product-disclaimer-container">
							<div aria-hidden="true" class="mdi mdi-information-outline">
							  <div class="product-disclaimer-text">You are licensing a digital product for a set
								duration.Durations are set forth in the product description, with "Lifetime" typically
								meaning five (5) years of online access and permanent download to a supported device.All
								licenses are non-transferrable. <a href="https://textbookx.zendesk.com/hc/en-us/articles/28012667853079-CA-Disclosure-Support-Page" target="_blank">More details can be found here</a>.
							  </div>
							</div>
						  </div>
						</div>
					  </div>
						<div class="co-submit-panel">
							<order-summary
								:charges="summary.charges"
								:payments="summary.payments"
								:total="summary.total"
								v-bind="ADAattr('sr-only')"
							></order-summary>
							<v-btn
									:dark="submit_enabled && !placing_order"
									color="#2170f2"
									@click="submit"
									class="mx-0"
									id="submit-payment"
									v-bind="ADAattr('button-readonly', !submit_enabled || placing_order,
									`Submit payment for $${formatPrice(summary['total'])}`,
									!submit_enabled ? 'Please check all fields before continue' : 'Please wait')"
							>
								Submit Payment
							</v-btn>

							<div class="co-submit-total" v-if="summary['total']">
								Order Total: <strong>${{ formatPrice(summary['total']) }}</strong>
							</div>
						</div>
						<div class="co-submit-panel" v-if="$globs['is_inst']">
							<v-checkbox
									:disabled="placing_order"
									v-model="share_order_info"
									label="I agree to allow my order information to be shared with my school administration"
									hide-details
							></v-checkbox>
						</div>
					</div>
				</v-card>
			</div>
		</v-flex>

		<v-flex mb2 d-flex xs12 pa-0 v-if="step < $const.STEP_PAYMENT">
			<div class="co-section" v-bind="ADAattr('hidden')">
				<v-card flat>
					<div>
						<div class="co-section-todo">
							<h2>
								Payment
							</h2>
							<p>
								Select Payment Methods
							</p>
						</div>
					</div>
				</v-card>
			</div>
		</v-flex>

		<v-dialog
				v-model="captcha_dialog"
				width="500"
		>
			<v-card v-bind="[
				ADAattr('dialog', !captcha_dialog, 'ada-cptd'),
				ADAfocus('captcha_dialog')
			]">
				<v-card-title
						class="headline grey lighten-2"
						primary-title
						v-bind="ADAattr('h2')"
						id="ada-cptd"
				>
					Please Confirm You Are Not a Robot
				</v-card-title>

				<v-card-text>
					<vue-recaptcha
							ref="recaptcha_coupon"
							@verify="onCaptchaVerify"
							:sitekey="$globs['captcha_settings']['public_key']"
							size="normal"
					>
					</vue-recaptcha>
				</v-card-text>

				<v-divider v-bind="ADAattr('hidden')"></v-divider>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
							color="primary"
							flat
							@click="captcha_dialog = false"
							v-bind="ADAattr('label', 'Return')"
					>
						Cancel
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
	import BraintreeCCForm from './BraintreeCCForm';
	import ApplePayButton from './ApplePayButton';
	import GooglePayButton from './GooglePayButton';
	import PayPalButtons from './PayPalButtons';
	import SinglePaymentMethod from './SinglePaymentMethod';
	import StudentCardForm from './StudentCardForm';
	import OrderSummary from './OrderSummary';
	import WithRoot from "./WithRoot";
	import EditCreditCardForm from "./EditCreditCardForm";
	import _ from 'lodash';
	import Axios from 'axios';
	import {EventBus} from './../includes/EventBus';
	import {formatBraintreeFieldName, formatPrice, parseErrorResponse} from './../includes/Miscellaneous';
	import VueRecaptcha from 'vue-recaptcha';

	class Address {
		constructor(data = {}) {
			this.id = data['id'] || '';
			this.name = data['name'] || '';
			this.line1 = data['line1'] || '';
			this.line2 = data['line2'] || '';
			this.city = data['city'] || '';
			this.state = data['state'] || '';
			this.postal_code = data['postal_code'] || '';
			this.country = data['country'] || '';
			this.phone = data['phone'] || '';
			this.source = data['source'] || '';
		}
	}

	class PaymentMethod {
		constructor(type, data) {
			const self = this;
			self.type = type;

			_.forEach(data, (v, k) => {
				self[k] = v;
			});
		}
	}

	export default {
		name: "PaymentMethods",

		components: {
			'braintree-cc-form': BraintreeCCForm,
			ApplePayButton,
			GooglePayButton,
			PayPalButtons,
			SinglePaymentMethod,
			StudentCardForm,
			OrderSummary,
			EditCreditCardForm,
			VueRecaptcha,
			'with-root': WithRoot
		},
		props: {
			payments: {
				type: Object,
			},
			items: {
				type: Array,
			},
			step: {
				type: Number,
			},
			summary: {
				type: Object,
			},
			customerToken: {
				type: String,
				default: '',
			},
			flexpayStore: {
				type: String,
				default: null,
			},
			orderData: {
				type: Object,
			},
			taxExempt: {
				type: Object,
			},
			is_logged_in: {
				type: Boolean,
			},
			placing_order: {
				type: Boolean,
				default: false,
			},
			enableSameAddressAsShipping: {
				type: Boolean,
				default: false,
			},
		},

		data() {
			return {
				add_coupon_code: '',
				add_discount_code: '',
				applied_discount: null,
				share_order_info: this.$globs['is_inst'],
				edit_cc: null,

				flexpay: {
					username: '',
					password: '',
				},

				selected_restricted_method: null,
				eligible_items: null,

				password: {
					form: false,
					first: '',
					second: '',
				},

				rules: {
					password1: [
						v => v.trim().length > 0 || !this.account_required || "Account is required",
						v => (v.length === 0 || v.trim().length >= 8) || "Min 8 characters",
						v => /^(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*()\-_+=`~{}\[\]'";:|<>,.\/ ]).{8,}$/.test(v) || "Must contain at least one uppercase, lowercase, special character",
					],
					password2: [
						v => this.password.first === '' || v !== '' || "Please re-type your password",
						v => v === this.password.first || "Passwords don't match",
						v => /^(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*()\-_+=`~{}\[\]'";:|<>,.\/ ]).{8,}$/.test(v) || "Must contain at least one uppercase, lowercase, special character",
					],
					sc_cvv: [
						v => v.length === 3 || "CVV is required",
					],
				},

				third_party_enabled: true,
				captcha_dialog: false,
				captcha_response: null,
				payPalPaymentData: null,
				googlePayPaymentData: null,
				applePayPaymentData: null,

				sc_cvv_model: false,
				sc_cvv: '',

				braintree_invalid_fields: [],
				edit_cc_invalid_fields: [],
				braintree_device_data: '',
				edit_cc_error: null,
				saving_edited_cc: false,
			};
		},

		watch: {
			'payments.credit_cards'(val, old) {
				const self = this;

				if (!self.payments.credit_cards) return;

				if (val['options'] && val['options'].length > 0) {
					self.payments.credit_cards.selected_cc = _.findIndex(val['options'], cc => self.enabledCC(cc));
				} else {
					self.payments.credit_cards.selected_cc = -1;
				}

				self.updatePaymentMethodsAvailability();
			},

			summary() {
				this.updatePaymentMethodsAvailability();
			},
		},

		methods: {
			formatPrice,
			formatBraintreeFieldName,

			async submit() {
				const self = this;
				const payments = await self.payments_data;

				self.edit_cc = null;
				self.edit_cc_error = null;

				if (
					self.payments.credit_cards &&
					self.payments.credit_cards.use_cc &&
					self.payments.credit_cards.selected_cc === -1 &&
					!self.hide_cc_selector &&
					!self.flexpay.username.length
				) {
					switch (self.payments.credit_cards.cc_type) {
						case "cc": {
							let bt = await self.$refs.braintree_hosted_fields_form.submit();

							if (bt === null || !bt.success) {
								const has_invalid_fields = bt && bt.data && bt.data.details && bt.data.details.invalidFieldKeys && bt.data.details.invalidFieldKeys.length > 0;
								const all_fields_are_empty = bt && bt.data && bt.data.code && bt.data.code === "HOSTED_FIELDS_FIELDS_EMPTY";

								let msg = "Please check your payment data";
								self.braintree_invalid_fields = [];

								if (all_fields_are_empty) {
									msg = "Please enter your Credit Card information";
									self.braintree_invalid_fields = ['number', 'expirationDate', 'cvv'];
								} else if (has_invalid_fields) {
									msg = "Please check the following fields: " + self.formatBraintreeFieldName(bt.data.details.invalidFieldKeys);
									self.braintree_invalid_fields = bt.data.details.invalidFieldKeys;
								}

								EventBus.$emit('show-message', {
									msg,
									severity: 2,
								});
								return;
							}

							payments.account_number = bt.data.nonce;
							payments.device_data = bt.data.device_data;
							payments.card_type = bt.data.card_type;
							payments.billing_address = bt.data.billing_address;
							payments.save_cc = bt.data.save_cc;
							payments.label = bt.data.label;
							payments.cardholder_name = bt.data.cardholder_name;
							if (!payments.selected) payments.selected = !!payments.account_number;

							break;
						}

						case "sc": {
							let sc = self.$refs.student_card_form.submit();

							if (sc === null) {
								EventBus.$emit('show-message', {
									msg: "Please check your payment data",
									severity: 2,
								});
								return;
							}

							payments.account_number = sc.data.number;
							payments.card_type = sc.data.card_type;
							payments.cvv = sc.data.cvv;
							payments.exp_year = sc.data.exp_year;
							payments.exp_month = sc.data.exp_month;
							payments.label = sc.data.label;
							payments.billing_address = sc.data.billing_address;
							payments.save_cc = sc.data.save_cc;
							payments.cardholder_name = sc.data.cardholder_name;
							if (!payments.selected) payments.selected = !!payments.account_number;

							break;
						}
					}
				}

				if (self.$refs.save_password_form && !self.$refs.save_password_form.validate()) {
					return;
				}

				if (self.$refs.sc_cvv_form) {
					if (_.isArray(self.$refs.sc_cvv_form)) {
						if (self.$refs.sc_cvv_form.length > 0 && !self.$refs.sc_cvv_form[0].validate()) {
							return;
						}
					} else {
						if (!self.$refs.sc_cvv_form.validate()) {
							return;
						}
					}
				}


				if (
					self.payments.credit_cards &&
					self.payments.credit_cards.use_cc &&
					self.payments.credit_cards.cc_type === 'cc' &&
					!payments.device_data
				){
					payments.device_data = self.braintree_device_data;
				}

				self.$emit('submit', {
					success: true,
					data: payments,
				});
			},

			onBraintreeSubmit(payload) {

			},

			onEditCreditCardSubmit(payload) {
				const self = this;

				let data = {
					id: this.edit_cc.id,
					...payload,
				};

				delete data['valid'], data['name'], data['country'], data['source'];

				self.saving_edited_cc = true;
				self.edit_cc_error = null;

				Axios.post('/sc/rest/index.php/edit_credit_card/', data).then(({data}) => {
					if (data) {
						if (data.success) {
							self.edit_cc = null;
							self.payments.credit_cards.options[self.payments.credit_cards.selected_cc] = data.credit_card;
						} else {
							self.edit_cc_error = data.error;
						}
					} else {
						self.edit_cc_error = "Can't save CC at this time";
					}

					self.saving_edited_cc = false;
				}).catch((error) => {
					self.edit_cc_error = "Can't save CC at this time";
					self.saving_edited_cc = false;

					EventBus.$emit('show-message', {
						msg: parseErrorResponse(error.response),
						severity: 2,
					});
				});
			},

			onStudentCardSubmit(payload) {

			},

			onBraintreeDeviceDataReceived(device_data) {
				this.braintree_device_data = device_data;
			},

			applyCoupon() {
				const self = this;

				if (self.$globs['captcha_settings'] && self.$globs['captcha_settings']['show_gc_captcha'] && !self.captcha_response) {
					self.captcha_dialog = true;
					return;
				}

				Axios.post('/sc/rest/index.php/add_certificate/' + self.customerToken, {
					code: self.add_coupon_code,
					captcha_response: self.captcha_response,
				}).then(({data}) => {
					self.add_coupon_code = '';

					self.$emit('applied-coupon', {
						success: true,
						data,
					});
				}).catch((error) => {
					if (error.response && error.response['data'] && error.response['data']['error'] && error.response['data']['error']['data']) {
						self.$globs['captcha_settings']['show_gc_captcha'] = !!error.response['data']['error']['data']['show_captcha'];
					}

					self.resetCaptchas();

					self.$emit('applied-coupon', {
						success: false,
						error: parseErrorResponse(error.response),
					});
				});

			},

			applyDiscount() {
				const self = this;

				Axios.post('/sc/rest/index.php/check_promotion/' + self.customerToken, {code: self.add_discount_code}).then(({data}) => {
					self.applied_discount = data;
					self.add_discount_code = '';

					self.$emit('applied-discount', {
						success: true,
						data,
					});
				}).catch((error) => {
					self.applied_discount = null;

					self.$emit('applied-discount', {
						success: false,
						error: parseErrorResponse(error.response),
					});
				});
			},

			onPaymentMethodSelected(payload) {
				const self = this;
				self.updatePaymentMethodsAvailability();

				if (payload && payload['method']['has_restrictions']) { // came from SinglePaymentMethod
					self.selected_restricted_method = payload['method']['selected'] ? payload : null;
					self.eligible_items = null;

					_.forEach(self.available_payment_methods, method => {
						switch (method.type) {
							case 'financial_aid':
								if (method.has_restrictions && method.type !== payload['type']) {
									method.enabled = !self.selected_restricted_method;
								}
								break;

							case 'gift_certificates':
								_.forEach(method.options, option => {
									if (option.has_restrictions && option.id !== payload['method']['id']) {
										option.enabled = !self.selected_restricted_method;
									}
								});
								break;

						}
					});

					if (self.selected_restricted_method) {

						Axios.post('/sc/rest/index.php/get_eligible_products/', {
							address_id: self.orderData.address_id,
							shipping_methods: self.orderData.shipping_methods,
							promotion_code: self.applied_discount ? self.applied_discount.code : null,
							gift_certificate_id: self.selected_restricted_method['type'] === 'financial_aid' ? 'financial_aid' : self.selected_restricted_method['method']['id'],
							tax_exempt: self.taxExempt,
						}).then(({data}) => {

							self.eligible_items = data['eligible'];

							self.$emit('selected-restricted-method', {
								payment: self.selected_restricted_method,
								eligible_lines: self.eligible_items,
							});

							self.$emit('updated-payment-method', payload);
						});

					} else {
						self.$emit('selected-restricted-method', null);
						self.$emit('updated-payment-method', payload);
					}
				} else {
					self.$emit('updated-payment-method', payload);
				}
			},

			isPaymentMethodRestricted(method) {
				return !!method.has_restrictions;
			},

			isFinancialAidRestricted() {
				const self = this;
				return self.payments.financial_aid ? self.payments.financial_aid.has_restrictions : false;
			},

			isVoucherRestricted(voucher) {
				const self = this;
				return;
			},

			updatePaymentMethodsAvailability() {
				const self = this;
				let cc_payment = _.get(_.find(self.summary.payments, {name: 'cc_payment'}), 'value', 0);
				console.log("self.summary", self.summary, cc_payment);

				if (self.payments.credit_cards) {
					console.log("use_cc", self.payments.credit_cards, self.payments.credit_cards.use_cc, self.payments.credit_cards.enabled);
					self.payments.credit_cards.enabled = (!self.summary.total || cc_payment > 0) && !self.$globs['required_cc'];
					self.payments.credit_cards.use_cc = (self.payments.credit_cards.use_cc && self.payments.credit_cards.enabled) || self.$globs['required_cc'];
				}
				self.third_party_enabled = !self.summary.total || cc_payment > 0;
			},

			log(data) {
				console.error(arguments);
			},

			getPaymentMethodCaption() {
				if (this.selected_restricted_method === null) return '';

				switch (this.selected_restricted_method['type']) {
					case 'financial_aid':
						return this.payments.financial_aid.label || 'Book Voucher';

					case 'gift_certificate':
						return this.selected_restricted_method['method']['type_full'];
				}
			},

			onPayPalTokenized(resp) {
				this.payPalPaymentData = resp;
				this.payments.credit_cards.use_cc = false;
				this.$emit('selected-online-method', 'PayPal');
			},
			onGooglePayTokenized(resp) {
				this.googlePayPaymentData = resp;
				this.payments.credit_cards.use_cc = false;
				this.$emit('selected-online-method', 'Google Pay');
			},
			onApplePayTokenized(resp) {
				this.applePayPaymentData = resp;
				this.payments.credit_cards.use_cc = false;
				this.$emit('selected-online-method', 'Apple Pay');
			},
			cancelPayPalPayment() {
				this.payPalPaymentData = null;

				if (typeof sendGAAction === 'function') {
					sendGAAction('PayPal payment cancelled');
				}
				this.$emit('canceled-online-method');
			},
			cancelGooglePayPayment() {
				this.googlePayPaymentData = null;

				if (typeof sendGAAction === 'function') {
					sendGAAction('Google Pay payment cancelled');
				}
				this.$emit('canceled-online-method');
			},
			cancelApplePayPayment() {
				this.applePayPaymentData = null;

				if (typeof sendGAAction === 'function') {
					sendGAAction('Apple Pay payment cancelled');
				}
				this.$emit('canceled-online-method');
			},

			enabledCC(cc) {
				return !this.$globs['has_rental'] || cc['allowed_for_rental'];
			},

			onCaptchaVerify(response) {
				this.captcha_response = response;
				this.captcha_dialog = false;
			},

			resetCaptchas() {
				this.captcha_response = null;

				if (this.$refs['recaptcha']) {
					this.$refs['recaptcha'].reset();
				}
				if (this.$refs['recaptcha_coupon']) {
					this.$refs.recaptcha_coupon.reset();
				}
			},

			doTracking() {
				if (typeof sendFBPixelAction === 'function') {
					sendFBPixelAction('AddPaymentInfo', {});
				}
				if (typeof sendGAAction === 'function') {
					sendGAAction('Checkout: saved CC selected');
				}
			},

			onUpdatedFinancialAid(payload) {
				this.$emit('updated-financial-aid', payload);
			},

			onChangedCC() {
				this.sc_cvv = '';
				this.doTracking();
			},
			dismissError(name) {
				this.braintree_invalid_fields = _.without(this.braintree_invalid_fields, name);
			},
		},

		mounted() {
			const self = this;
			self.edit_cc = null;
			self.edit_cc_error = null;

			EventBus.$on('error-dismissed', (name) => {
				self.dismissError(name);
			});
		},

		computed: {
			account_required() {
				return this.$globs['account_required'] || this.$globs['has_rental'] || this.$globs['has_exchange'];
			},

			available_payment_methods() {
				const self = this;
				let methods = [];

				if (self.payments.financial_aid && self.$globs['gift_certificates_enabled']) {
					methods.push(new PaymentMethod('financial_aid', self.payments['financial_aid']));
				}

				if (self.payments.gift_certificates && self.payments.gift_certificates.options && self.$globs['gift_certificates_enabled']) {
					methods.push(new PaymentMethod('gift_certificates', self.payments['gift_certificates']));
				}

				return methods;
			},

			all_items() {
				const self = this;
				const result = [];

				_.forEach(self.items, section => {
					_.forEach(section.books, item => {
						result.push(item);
					});
				});

				return result;
			},

			permitted_items() {
				const self = this;
				const result = [];

				if (self.selected_restricted_method === null || self.eligible_items === null) return result;

				_.forEach(self.all_items, item => {
					if (self.eligible_items.includes(item.shopping_cart_line_id)) {
						result.push(item);
					}
				});

				return result;
			},

			non_permitted_items() {
				const self = this;
				const result = [];

				if (self.selected_restricted_method === null || self.eligible_items === null) return result;

				_.forEach(self.all_items, item => {
					if (!self.eligible_items.includes(item.shopping_cart_line_id)) {
						result.push(item);
					}
				});

				return result;
			},

			permitted_subtotal() {
				return this.summary && this.summary['split_totals'] && this.summary['split_totals']['restricted_total']
					? parseFloat(this.summary['split_totals']['restricted_total']) : null;
			},

			non_permitted_subtotal() {
				return this.summary && this.summary['split_totals'] && this.summary['split_totals']['unrestricted_total']
					? parseFloat(this.summary['split_totals']['unrestricted_total']) : null;
			},

			hide_cc_selector() {
				return !!this.payPalPaymentData || !!this.googlePayPaymentData || !!this.applePayPaymentData;
			},

			show_split_payment() {
				return this.selected_restricted_method !== null && this.non_permitted_items && this.non_permitted_items.length > 0;
			},

			has_ebook() {
			 return !!this.$globs['has_ebook'];
			},

			contained_required_types() {
				const types = [];
				if (this.$globs['has_exchange']) types.push("Marketplace");
				if (this.$globs['has_rental']) types.push("Rental");
				if (this.$globs['has_akademos_ebook']) types.push("Ebook");

				const last = types.length > 1 ? ' and ' + types.pop() : '';

				return types.join(', ') + last;
			},

			amount_to_authorize() {
				return this.summary['cc_payment'];
			},
		},

		asyncComputed: {
			async payments_data() {
				const self = this;
				const gcs = self.payments.gift_certificates && self.payments.gift_certificates.options
					? _.map(
						_.filter(self.payments.gift_certificates.options, opt => opt.selected), x => x.id)
					: [];

				let payments = {
					financial_aid: self.payments.financial_aid ? self.payments.financial_aid.selected : null,
					gift_certificates: gcs,
					promotion_code: self.applied_discount ? self.applied_discount.code : null,
					credit_card_id: null,
					share_order_info: self.share_order_info,
					device_data: '',
					account_number: null,
					card_type: null,
					billing_address: null,
					customer_password: self.password.first,
					customer_password_confirm: self.password.second,
					captcha_response: self.captcha_response,
					selected: (self.payments.financial_aid && self.payments.financial_aid.selected) || gcs.length > 0,
					selected_restricted_method: self.selected_restricted_method !== null,
					eligible_items_loaded: self.eligible_items !== null
				};

				if (self.flexpayStore) {

					payments.card_type = 'FLEXPAY';
					payments.flexpay = {
						username: self.flexpay.username,
						password: self.flexpay.password,
						storeNumber: self.flexpayStore,
					};

					if (!payments.selected) payments.selected = !!self.flexpay.username && !!self.flexpay.password;

				} else if (self.googlePayPaymentData) {

					payments.card_type = 'GOOGLEPAY';
					payments.account_number = self.googlePayPaymentData.nonce;
					if (!payments.selected) payments.selected = !!payments.account_number;

				} else if (self.payPalPaymentData) {

					payments.card_type = 'PAYPAL';
					payments.account_number = self.payPalPaymentData.nonce;
					if (!payments.selected) payments.selected = !!payments.account_number;

				} else if (self.applePayPaymentData) {

					payments.card_type = 'APPLEPAY';
					payments.account_number = self.applePayPaymentData.nonce;
					if (!payments.selected) payments.selected = !!payments.account_number;

				} else if (self.payments.credit_cards && self.payments.credit_cards.use_cc && self.payments.credit_cards.selected_cc === -1) {
					// New CC
					// call form validation in submit method to prevent submitting cc forms upon showing payments step and every update of this computed
					// and only update selected here to enable/disable order placement
					payments.selected = true;

				} else {
					// Saved CC

					if (self.payments.credit_cards && self.payments.credit_cards.use_cc && self.payments.credit_cards.selected_cc >= 0) {
						const sel_cc = self.payments.credit_cards.options[self.payments.credit_cards.selected_cc];
						payments.credit_card_id = self.enabledCC(sel_cc) ? sel_cc.id : null;
						if (sel_cc && sel_cc.card_type === 'SC') {
							payments.cvv = self.sc_cvv;
						}
					} else {
						payments.credit_card_id = null;
					}

					if (!payments.selected) payments.selected = !!payments.credit_card_id;
				}

				return payments;
			},

			async submit_enabled() {
				const pd = await this.payments_data;
				return pd && pd.selected && (!pd.selected_restricted_method || pd.eligible_items_loaded);
			},
		},
	};
</script>

<style scoped lang="less">
	@text_highlight_color: #4185f4;

	.co-section {
		padding: 4px;
	}

	.co-submit-panel {
		display: flex;
		align-items: center;

		.co-submit-total {
			padding-left: 25px;
			font-size: 16px;
		}
	}

	.co-payments-sections-container {
		width: 100%;

		.co-payments-sections {
			.co-payments-section-with-permissions,
			.co-payments-section-without-permissions {
				.co-payments-section-books {
					padding: 0 30px;

					h3 {
						color: #898C90;
						font-weight: normal;
					}

					.co-permissions-totals {
						padding-top: 10px;
						border-top: 1px solid #ccc;
						margin-top: 10px;
					}
				}
			}

			.co-payments-section-with-permissions {
				padding: 20px 0 20px 24px;
				border-bottom: 1px solid #ccc;
			}

			.co-payments-section-without-permissions {
				padding: 20px 0 0 24px;
			}

			.co-payments-section-no-permissions {
				padding: 0 0 0 24px;
			}

			.co-payments-section-additional {
				padding: 0 0 0 24px;
			}

			ul.co-products-list {
				list-style: none;
				padding: 10px 0 0;

				> li {
					overflow: hidden;
					padding: 10px 0;

					&:first-child {
						border-top: none;
					}

					h3 {
						color: #767676;
						font-size: 16px;
						font-weight: normal;
						margin-bottom: 10px;
						text-transform: uppercase;
					}

					.copl-cover {
						display: block;
						float: left;
						width: 8%;
						margin-right: 2%;
					}

					.copl-info {
						display: block;
						box-sizing: border-box;
						float: left;
						width: 90%;
						padding: 0;

						h4 {
							font-size: 15px;
						}

						div {
							font-size: 14px;
						}
					}
				}
			}


			/deep/ .co-payments-container-radio-group {
				width: 100%;

				> .v-input__control {
					flex-grow: 1;
				}
			}

			.co-payments-container {
				overflow: hidden;
				width: 100%;

				.co-payments-section-content {
					padding: 20px;
				}

			}

			&.co-payments-sections-brief {
				> ul {
					list-style: none;
					margin: 0;
					padding: 0 0 0 40px;

					> li {
						font-size: 16px;
						padding: 5px 0;
					}
				}
			}

			/deep/ ul.co-payments-selector {
				list-style: none;
				padding: 0;
				margin: 0;

				> li {
					.co-select-cc-rg {
						.v-input__control {
							flex-grow: 1 !important;
						}
					}

					&.cops-cc {
						ul.cops-ccs-list {
							list-style: none;

							> li {
								padding: 15px 0px;
								border-bottom: 1px solid #E0E0E0;
							}
						}

						.co-cc-type-selector-container {
							padding: 16px 0 0 0;

							.co-cc-type-selector-title {
								padding: 0 0 0 28px;
							}

							.co-cc-type-selector {
								padding: 0 0 0 48px;
							}
						}
					}


					.cops-3rd-party {
						border-bottom: 1px solid #E0E0E0;
						padding: 0 0 20px;
						margin-bottom: 20px;
						display: flex;
						justify-content: flex-start;

						.cops-3rd-party-btn {
							max-width: 280px;
						}

						.cops-3rd-party-btn2 {
							max-width: 280px;
						}

						.add-margin-a {
							margin-top: 5px;
						}

						.add-margin-g {
							margin-top: 4px;
						}

						.flex {
							&:empty {
								display: none;
								flex: none;
							}
						}

					}

					.cops-flexpay {
						margin-bottom: 20px;
					}

					.cops-add {
						padding-top: 20px;

						@media screen and (max-width: 600px) {
							flex-direction: column;
						}

						.cops-add-caption {
							flex: 0 0 100%;
						}
					}

					.co-code-submit-btn-block {
						padding-top: 7px;
						margin-top: -5px;
					}
				}
			}
		}

		.co-save-password-block {
			margin-top: 10px;
			border-top: 1px solid #E0E0E0;

			.co-save-password-block-title {
				margin-bottom: 10px;
				color: @text_highlight_color;
			}

			.co-save-password-form {
				margin: 0 0 15px;
			}
		}
	}

	.co-captcha-panel {
		margin: 10px 0;
		border-top: 1px solid #E0E0E0;
		padding: 15px 24px 0;
		@media screen and (max-width: 600px) {
			padding: 10px 0 0;
			display: flex;
			justify-content: center;
			max-width: 100vw;
		}
	}

	.third-party-payment-info-block {
		align-items: center;

		p {
			flex: 1;
			margin-bottom: 0;
		}
	}

	.co-submit-placing-order {
		padding: 30px 32px 20px;

		h4 {
			font-weight: normal;
			font-style: italic;
			font-size: 18px;
		}
	}

	/deep/ .v-text-field .v-label {
		top: 6px !important;
	}

	/deep/ .co-sc-cvv-block {
		padding: 0 0 16px 48px !important;

		.v-input {
			padding-top: 0;
			margin-top: 0;
		}
	}

</style>
